"use strict";import{SideNav as e}from"./src/Sidenav.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-sidenav",e);
//# sourceMappingURL=sp-sidenav.js.map
